export const ADD_CARD = "ADD_CARD"
export const ADD_CARD_SUCCESSFUL = "ADD_CARD_SUCCESSFUL"
export const ADD_CARD_FAILED = "ADD_CARD_FAILED"
export const RESET_CARD_ALERT = "RESET_CARD_ALERT"
export const GET_CARD_LIST = "GET_CARD_LIST"
export const GET_CARD_LIST_SUCCESSFUL = "GET_CARD_LIST_SUCCESSFUL"
export const GET_CARD_LIST_FAILED = "GET_CARD_LIST_FAILED"
export const REMOVE_CARD = "REMOVE_CARD"
export const REMOVE_CARD_SUCCESSFUL = "REMOVE_CARD_SUCCESSFUL"
export const REMOVE_CARD_FAILED = "REMOVE_CARD_FAILED"
export const DEFAULT_CARD = "DEFAULT_CARD"
export const DEFAULT_CARD_SUCCESSFUL = "DEFAULT_CARD_SUCCESSFUL"
export const DEFAULT_CARD_FAILED = "DEFAULT_CARD_FAILED"
export const GET_INVOICES = "GET_INVOICES"
export const GET_INVOICES_SUCCESSFUL = "GET_INVOICES_SUCCESSFUL"
export const GET_INVOICES_FAILED = "GET_INVOICES_FAILED"
export const GET_PLAN = "GET_PLAN_DETAILS"
export const GET_PLAN_SUCCESSFUL = "GET_PLAN_DETAILS_SUCCESSFUL"
export const GET_PLAN_FAILED = "GET_PLAN_DETAILS_FAILED"
export const API_CALL_ERROR = "API_CALL_ERROR"
export const ADD_BILL_ADDRESS = "ADD_BILL_ADDRESS"
export const ADD_BILL_ADDRESS_SUCCESSFUL = "ADD_BILL_ADDRESS_SUCCESSFUL"
export const ADD_BILL_ADDRESS_FAILED = "ADD_BILL_ADDRESS_FAILED"
export const EDIT_BILL_ADDRESS = "EDIT_BILL_ADDRESS"
export const EDIT_BILL_ADDRESS_SUCCESSFUL = "EDIT_BILL_ADDRESS_SUCCESSFUL"
export const EDIT_BILL_ADDRESS_FAILED = "EDIT_BILL_ADDRESS_FAILED"
export const GET_BILL_ADDRESS_DETAILS = "GET_BILL_ADDRESS_DETAILS"
export const GET_BILL_ADDRESS_DETAILS_SUCCESSFUL = "GET_BILL_ADDRESS_DETAILS_SUCCESSFUL"
export const GET_BILL_ADDRESS_DETAILS_FAILED = "GET_BILL_ADDRESS_DETAILS_FAILED"
export const ADD_CARD_RESET = "ADD_CARD_RESET"
export const GET_TIMEZONES_LIST = 'GET_TIMEZONES_LIST'
export const UPDATE_TIMEZONE = 'UPDATE_TIMEZONE'
export const SET_TIMEZONES_LIST = 'SET_TIMEZONES_LIST'
export const SET_SETUP_POPUP = 'SET_SETUP_POPUP'
export const SET_PAYEMENT_INFO = 'SET_PAYEMENT_INFO'

